import { Loading } from 'element-ui';

let loading
const Tools = {
    loadingShow() {
        loading = Loading.service({});
      },
      loadingHide() {
        loading.close();
      },
    // 登陆
    toLogin() {
        location.href = location.origin + '/wechat_manage/index.html#/login'
        // if (sessionStorage.getItem("isTest")) {
        //     location.href = '#/login'
        // } else {
        //     location.href = location.origin + process.env.VUE_APP_API + API.login;
        // }
    },
    // 获取URL参数
    getUrlParamsString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    getCookie(name){
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            
            return decodeURI(arr[2]);
        } else {
            return null;
        }
    },

    //把cookie中的值存储到sessionStorage中   url:用户未登陆的情况下跳转到登录页地址
    cookieTosetItem(url){
        let cookieText = document.cookie;
        if(Tools.getCookie("token") &&  Tools.getCookie("token") != 'undefined') {
            document.cookie.split(";").forEach(item=>{
                let cookie = item.split("=");
                sessionStorage.setItem(cookie[0].trim(),decodeURI(cookie[1]))
            })
        }else {
            sessionStorage.clear();
            window.location.href=url;
        }
    },
       // 设置cookie的参数 name:名字  value:值
    setCookie(name,value){
        var enval = encodeURI(value);
        var Days = 30; 
        var exp = new Date(); 
        exp.setTime(exp.getTime() + 60*1000); 
        document.cookie = name + "="+ enval + ";path=/;expires=" + exp.toGMTString();  
    },

    // 时间戳
    fromatDate(timestemp) {
        if (timestemp == null) {
            return '';
        }
        var time = new Date(timestemp);
        var y = time.getFullYear(); //年
        var m = time.getMonth() + 1; //月
        var d = time.getDate(); //日
        var h = time.getHours(); //时
        var mm = time.getMinutes(); //分
        var s = time.getSeconds(); //秒
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        if (h < 10) {
            h = '0' + h;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        if (s < 10) {
            s = '0' + s;
        }
        return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
    },

    encode (str) {
        return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }
        ))
    },

    getCosPath() {
		// 获取服务器时间
		let date = new Date();
		let sdate = date.getFullYear() + "" + (date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1));
		// 生成UUID
		let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
			var r = (Math.random() * 16) | 0,
				v = c == "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
		return sdate + "/" + uuid;
		// console.log(this.cosPath)
	},
	getUuid() {
		let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
			var r = (Math.random() * 16) | 0,
				v = c == "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
		return uuid;
	},




}

/**
 * 使用方法
 * this.Tools.getUrlParamsString
 * 
 */
export default Tools;